"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
// entities
__export(require("./entity/Bucket"));
var Bucket_1 = require("./entity/Bucket");
exports.Bucket = Bucket_1.default;
__export(require("./entity/FileReference"));
var FileReference_1 = require("./entity/FileReference");
exports.FileReference = FileReference_1.default;
// stub instances
var StubBucket_1 = require("./stub/StubBucket");
exports.StubBucket = StubBucket_1.default;
var StubFileReference_1 = require("./stub/StubFileReference");
exports.StubFileReference = StubFileReference_1.default;
